export const formatReservoirName = (name) => {
  return String(name || "")
    .replace(/\s*(suv\s+ombori|сув\s+омбори)\s*$/i, "")
    .trim();
};
